import { THEME_EMOJI } from "@/lib/brand";

export const ThemeThumb = ({ k, t }) => (
  <div className="thumb" style={{ backgroundColor: t.vars["--bg"] }} data-testid={`theme-thumb-${k}`}>
    <span className="ico" aria-hidden="true">{THEME_EMOJI[k]}</span>
    <i style={{ background: t.vars["--accent"] }} /><em style={{ background: t.vars["--ink"] }} />
  </div>
);
